(() => {
  console.log('Variants Table script loaded!');
  const variants_table = document.getElementById('upng-variants-table');
  if(!variants_table) {
    console.error('Variants Table not found!');
    return;
  }

  // Get the rows of all the product variants.
  /**@type {NodeListOf<HTMLTableRowElement>} */
  let variant_rows = variants_table.querySelectorAll('tr[variant-id]');

  /**@type {HTMLButtonElement} */
  const add_to_cart_btn = document.querySelector('#upng-variant-table-add-to-cart-btn');

  // This map has the variantID as the key and the quantity as the value.
  const quantities_map = new Map();

  async function requestCartHtmlAndUpdate() {
    const toggle = document.querySelector('.cart__toggle');
    if (toggle) {
        toggle.click();
    }
    try {
      const req = await fetch(theme.routes.cart_url + "?section_id=api-cart-items");
      if(!req.ok) return false;
      const response = await req.text();
      const element = document.createElement("div");
      element.innerHTML = response;
      const cleanResponse = element.querySelector('[data-api-content]');
      this.cart.build(cleanResponse);
      return true;
    } catch(error) {
      console.error('Could not update the cart HTML ', error);
      return false;
    }
  }

  async function requestUpdateCart() {

    const updates = Object.fromEntries(quantities_map);
    console.log("requestUpdateCart "+JSON.stringify({ updates }));

    try {
      const req = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });
      if(!req.ok) {
        console.error('Cart could not be updated');
        console.error(req);
        return false;
      }
      return true;
    } catch(error) {
      console.error('Cart could not be updated, ', error);
      return false;
    }
  }

  async function updateCart() {
    // We send the data to Shopify.
    const success = await requestUpdateCart();
    if(!success) {
      console.error('Something went wrong trying to update the cart.');
      return;
    }
    // Now we need to visually update the cart.
    await requestCartHtmlAndUpdate();
  }


  /**
   * Initializes a row.
   * @param {HTMLTableRowElement} row 
   */
  function initRow(row) {
    const variant_id = row.getAttribute('variant-id');
    const sku = row.getAttribute('data-sku');
    const variant_unit_quantity_input = row.querySelector('.upng-unit-quantity-cell input');

    // If there is a unit price element, initialize it.
    if(variant_unit_quantity_input) {
      variant_unit_quantity_input.addEventListener('change', (e) => {
        const quantity = variant_unit_quantity_input.value;
        quantities_map.set(parseInt(variant_id), parseInt(quantity));
      });
    }

  }

  variant_rows.forEach((row) => initRow(row));
  variant_rows = variants_table.querySelectorAll('tr[variant-id]');

  add_to_cart_btn.addEventListener('click', () => {
    const loader = add_to_cart_btn.querySelector('.upng-tabla-variantes-loader');
    if(loader) loader.style.display = 'inline-block';
    add_to_cart_btn.disabled = true;
    updateCart().then(() => {
      if(loader) loader.style.display = 'none';
      add_to_cart_btn.disabled = false;
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    const variantTable = document.querySelector('variant-table');
    const optionButtons = document.querySelectorAll('.opt-btn');
    function updateVariantInfo(selectedVariant) {
      if (!selectedVariant) return;
      // Update image
      const variantImage = selectedVariant?.featured_media?.preview_image?.src;
      if (variantImage) {
        const mainImage = document.querySelector('#main-product-image');
        if (mainImage) mainImage.src = variantImage;
        
        const thumbnails = document.querySelectorAll('.thumbnail');
        thumbnails.forEach(thumbnail => {
          if (thumbnail.getAttribute('data-full-image') === variantImage) {
            document.querySelector('.thumbnail.active')?.classList.remove('active');
            thumbnail.classList.add('active');
          }
        });
      }
      // Update price
    try {
      const priceElement = document.querySelector('[data-product-price]');
      if (priceElement) {
        const price = selectedVariant.price / 100;
        priceElement.innerHTML = Shopify.currency.active === 'EUR'
          ? `€${price.toFixed(2).replace('.', ',')}`
          : `${Shopify.currency.active} ${price.toFixed(2).replace('.', ',')}`;
      }
      const comparePriceElement = document.querySelector('[data-compare-price]');
      if (comparePriceElement && selectedVariant.compare_at_price) {
        const comparePrice = selectedVariant.compare_at_price/100;
        const formattedComparePrice = Shopify.currency.active === 'EUR'
          ? `€${comparePrice.toFixed(2).replace('.', ',')}`
          : `${Shopify.currency.active} ${comparePrice.toFixed(2).replace('.', ',')}`;
        comparePriceElement.innerHTML = formattedComparePrice;
        comparePriceElement.style.display = 'inline-block';
      } else if (comparePriceElement) {
        comparePriceElement.style.display = 'none';
      }
      const priceOffContainer = document.querySelector('[data-price-off]');
        const priceOffAmount = document.querySelector('[data-price-off-amount]');
        if (priceOffContainer && priceOffAmount && 
          selectedVariant.compare_at_price > selectedVariant.price) {
          const savings = selectedVariant.compare_at_price - selectedVariant.price;
          const formattedSavings = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: Shopify.currency.active,
            minimumFractionDigits: 2
          }).format(savings/100);
          
          priceOffAmount.innerHTML = formattedSavings;
          priceOffContainer.classList.remove('hidden');
        } else if (priceOffContainer) {
          priceOffContainer.classList.add('hidden');
        }
      } catch (error) {
        console.error('Error rendering product info:', error);
      }
    }

    optionButtons.forEach(button => {
      button.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        const variantsJson = variantTable.querySelector('script[type="application/json"]');
        const variants = JSON.parse(variantsJson?.textContent || '[]');
        const selectedVariant = variants.find(v => v.id.toString() === variantId);
        updateVariantInfo(selectedVariant);

        // Update URL
        if (variantTable.dataset.url !== 'false') {
          window.history.replaceState({}, '', `${variantTable.dataset.url}?variant=${variantId}`);
        }
      });
    });
  });
})();
